import { MessageCircle } from "lucide-react";
import { CONTACT } from "../data/mock";

export const WhatsAppBubble = () => (
  <a
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-bubble"
    aria-label="Chat with Levaze on WhatsApp"
    className="group fixed bottom-6 right-6 z-50 flex items-center gap-0 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-5px_rgba(37,211,102,0.5)] hover:shadow-[0_14px_36px_-5px_rgba(37,211,102,0.65)] transition-shadow duration-300"
  >
    <span className="flex items-center justify-center w-14 h-14">
      <MessageCircle size={26} className="group-hover:scale-110 transition-transform duration-200" />
    </span>
    <span className="max-w-0 group-hover:max-w-[140px] overflow-hidden whitespace-nowrap text-sm font-semibold group-hover:pr-5 transition-[max-width,padding] duration-300">
      Chat with us
    </span>
    <span className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 rounded-full bg-[#6C0B1B] border-2 border-white animate-pulse" />
  </a>
);
